import { IdValueType, KeyValueUserModel } from '@models/common';
import { FormItem } from '@shared/components/fields/common/fields.model';

export type NotificationFormData = {
  contractId: number;
  moduleId: number;
  /** Selected roles to notify */
  notify?: string[];
  /** Options for notify field */
  notifyOptions?: KeyValueUserModel<string>[];
  /** Roles to be excluded from notify options */
  excludeRoles?: number[];
  /** Whether to include attachments in the notification */
  includeAttachments?: boolean;
  /** Whether to hide the include attachments checkbox */
  hideIncludeAttachments?: boolean;
  /** Whether to hide the notify options */
  hideRolesNotify?: boolean;
};

export type NotificationFormValue = Pick<NotificationFormData, 'notify' | 'excludeRoles' | 'includeAttachments'>;

export type TransitionFormValue = {
  values: IdValueType<any, number>[];
  notificationData: NotificationFormValue;
};

export type TransitionFormData = {
  fields: FormItem[];
  signatureIsRequired?: boolean;
  contractId: number;
  moduleId: number;
  notificationData?: Omit<NotificationFormData, 'contractId' | 'moduleId'>;
};
